/**
 * Composer Text Tracking
 *
 * Tracks initial composer text set via form extraction (e.g., from T5 CTA)
 * to enable analytics comparison between pre-filled and submitted text.
 */

let initialComposerText: string | null = null;

export function setInitialComposerText(text: string): void {
  initialComposerText = text;
}

export function getInitialComposerText(): string | null {
  return initialComposerText;
}

export function clearInitialComposerText(): void {
  initialComposerText = null;
}
